var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
var Label = styled.label(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: ", ";\n  font-weight: bold;\n  padding-bottom: 0.3rem;\n  font-family: ", ";\n"], ["\n  font-size: ", ";\n  font-weight: bold;\n  padding-bottom: 0.3rem;\n  font-family: ", ";\n"])), function (props) { return props.theme.type.sizes.small; }, function (props) { return props.theme.type.family; });
export default Label;
var templateObject_1;
